/**
 * Customer testimonials — sourced from Google Business Profile.
 * GMB: "Thailand Elite - Long stay visas and privileges"
 * Place ID: ChIJHeLp1TCf4jARWU2JgXxAkPg
 * Rating: 4.8★ / 113 reviews (as of 2026-03-05)
 *
 * text    → default (EN unless review was originally in FR)
 * textFr  → French version (for thailandelite.fr)
 * textEn  → English version (for FR-original reviews shown on EN site)
 *
 * To refresh top 5 from API:
 * cd /home/node/workspaces/skills/google-ads && node /home/node/workspaces/skills/google-maps-scraper/gmaps.mjs details ChIJHeLp1TCf4jARWU2JgXxAkPg
 */

export interface Testimonial {
  author: string;
  country?: string;
  ratingValue: number;
  datePublished: string;
  /** Default display text (EN unless originally in French) */
  text: string;
  /** French translation — shown on FR domain (thailandelite.fr) */
  textFr?: string;
  /** English translation — shown on EN domain when review was originally in French */
  textEn?: string;
}

export const testimonials: Testimonial[] = [
  {
    author: "Patrick Morvan",
    country: "🇫🇷 France",
    ratingValue: 5,
    datePublished: "2026-02-05",
    text: "I would like to sincerely thank the entire team for their outstanding professionalism throughout the process of obtaining my Thailand Elite Visa. Everything was handled smoothly and efficiently. A special thank you to Maria for her incredible responsiveness, kindness, and constant support. Her dedication truly made the experience stress-free. Highly recommended!",
    textFr: "Je souhaite sincèrement remercier toute l'équipe pour leur professionnalisme exemplaire tout au long de mon dossier Thailand Elite. Tout a été géré de façon fluide et efficace. Un grand merci particulier à Maria pour sa réactivité, sa gentillesse et son soutien constant. Son dévouement a vraiment rendu l'expérience sans stress. Hautement recommandé !",
  },
  {
    author: "Glyn Pocock",
    country: "🇬🇧 United Kingdom",
    ratingValue: 5,
    datePublished: "2025-11-13",
    text: "I would like to say a special thank you to Maria G, for all her assistance and help throughout the application process. This lady made the process very easy to complete all the way through.",
    textFr: "Je tiens à adresser un remerciement particulier à Maria G. pour toute son aide tout au long du processus de demande. Cette dame a rendu chaque étape très facile à franchir, de bout en bout.",
  },
  {
    author: "Jaydone",
    ratingValue: 5,
    datePublished: "2025-10-23",
    text: "Maria helped me every step along the way with getting my Elite Visa, making the process super easy. I was very confused on a lot of things when I was considering getting this Visa or not, and she clarified everything amazingly and helped with so many things. A great experience and I'm very pleased with how everything went!",
    textFr: "Maria m'a accompagné à chaque étape pour l'obtention de mon visa Elite, rendant le processus très simple. J'avais beaucoup de questions avant de me lancer, et elle a tout clarifié admirablement. Une excellente expérience, je suis très satisfait du résultat !",
  },
  {
    author: "Raina Sarah Zaman",
    ratingValue: 5,
    datePublished: "2025-10-02",
    text: "The Thailand Elite service has been very good. I especially want to thank Miss Maria, who helped me many times whenever I had questions or issues. She was always kind and quick to assist. I really appreciate the support.",
    textFr: "Le service Thailand Elite a été très bon. Je tiens tout particulièrement à remercier Mlle Maria, qui m'a aidée à plusieurs reprises lorsque j'avais des questions. Elle a toujours été aimable et réactive. J'apprécie vraiment ce soutien.",
  },
  {
    author: "Alex Istranin",
    ratingValue: 5,
    datePublished: "2025-10-01",
    text: "I had a very positive experience working with this company. Communication was always clear, professional, and friendly. Every step of the process was handled with great attention to detail, and all my questions were answered quickly and thoroughly. I truly appreciate the excellent customer service and the personal approach, which made the whole experience smooth and stress-free. I would definitely recommend this company to others.",
    textFr: "J'ai eu une très bonne expérience avec cette entreprise. La communication était toujours claire, professionnelle et conviviale. Chaque étape a été gérée avec une grande attention aux détails et toutes mes questions ont reçu des réponses rapides et complètes. Un service client excellent, une approche personnalisée — je la recommande vivement.",
  },
  {
    author: "Mohamed Mouhtam Soubai",
    country: "🇲🇦 Morocco",
    ratingValue: 5,
    datePublished: "2025-08-07",
    text: "Excellent support with kindness and professionalism from Maria — you deserve more than 5 stars because you honor the name of this company.",
    textFr: "Un soutien excellent, avec gentillesse et professionnalisme de la part de Maria — vous méritez plus que 5 étoiles, car vous honorez le nom de cette entreprise.",
  },
  {
    author: "Wunda Stone",
    ratingValue: 5,
    datePublished: "2025-07-10",
    text: "So genuinely impressed with the level of care and professionalism from this elite expat visa service. I had a tight connection in Bangkok on my way to Koh Samui and was cutting it extremely close to my next boarding time. Not only did I make my flight, but I couldn't have done it without their spot-on, incredible on-ground support. The team truly went above and beyond. Their yearly gifts and premium touches are also such a classy bonus. Top-tier service that truly lives up to their impressive, hospitable title.",
    textFr: "Vraiment impressionné par le niveau d'attention et de professionnalisme de ce service de visa d'élite. L'équipe est allée bien au-delà de mes attentes. Leurs cadeaux annuels et leurs attentions premium sont également une touche de classe remarquable. Un service de premier ordre qui mérite pleinement son titre.",
  },
  {
    author: "Asa Earnest",
    country: "🇺🇸 United States",
    ratingValue: 5,
    datePublished: "2025-06-12",
    text: "We worked with Maria at Thailand Elite to secure our Elite visas. She has made the process so easy and understandable for us. We highly recommend!",
    textFr: "Nous avons travaillé avec Maria pour obtenir nos visas Elite. Elle a rendu le processus très simple et compréhensible. Nous recommandons vivement !",
  },
  {
    author: "Vincent Wong",
    ratingValue: 5,
    datePublished: "2025-06-05",
    text: "I felt very good about the entire application process. The response was efficient and well-organized. Maria, who handled my case, was exceptionally professional, responsive, and attentive throughout the entire process. Highly recommended.",
    textFr: "J'ai été très satisfait de l'ensemble du processus de candidature. Les réponses étaient efficaces et bien organisées. Maria, qui a géré mon dossier, s'est montrée exceptionnellement professionnelle, réactive et attentive. Fortement recommandé.",
  },
  {
    author: "ZH向阳而生",
    country: "🇨🇳 China",
    ratingValue: 5,
    datePublished: "2025-05-22",
    text: "The customer service responded quickly and accurately, and it was a good experience.",
    textFr: "Le service client a répondu rapidement et avec précision. Ce fut une très bonne expérience.",
  },
  {
    author: "David Liew",
    ratingValue: 5,
    datePublished: "2025-05-01",
    text: "I truly recommend this to everyone who seeks consultation regarding the elite visa in Thailand. Exceptional customer service makes the application process more exciting and easier.",
    textFr: "Je recommande vivement à toute personne souhaitant obtenir un visa Elite en Thaïlande. Le service client exceptionnel rend le processus de candidature plus agréable et bien plus simple.",
  },
  {
    author: "Dominique Simon",
    country: "🇫🇷 France",
    ratingValue: 5,
    datePublished: "2025-05-01",
    // Originally in French — FR is default text
    text: "Un peu compliqué au début, mais dès que j'ai eu une interlocutrice telle que Maria, j'ai eu des réponses claires et précises jusqu'à maintenant. J'espère donc obtenir mon visa dans les meilleures conditions.",
    textEn: "A bit complicated at first, but once I had Maria as my contact, I received clear and precise answers every time. I'm looking forward to obtaining my visa in the best possible conditions.",
  },
  {
    author: "Jonny Splints",
    ratingValue: 5,
    datePublished: "2025-03-20",
    text: "Maria was excellent and easy to deal with. Great and seamless process!",
    textFr: "Maria était excellente et très facile à contacter. Un processus fluide et sans accroc !",
  },
  {
    author: "Philippe Guichard",
    country: "🇫🇷 France",
    ratingValue: 5,
    datePublished: "2025-01-26",
    text: "Thailand Elite website is very user-friendly, visa registrations are quick and the help from the live team is very efficient.",
    textFr: "Le site web de Thailand Elite est très convivial, les inscriptions de visa sont rapides et l'aide de l'équipe en direct est très efficace.",
  },
  {
    author: "Andre Frans",
    ratingValue: 5,
    datePublished: "2025-02-15",
    text: "Easy to apply with help from the staff.",
    textFr: "Très facile à faire avec l'aide de l'équipe.",
  },
  {
    author: "Music Hearer",
    ratingValue: 5,
    datePublished: "2024-12-20",
    text: "I have truly enjoyed the application process from the very beginning thanks to the great service I received from Maria. Communication with her was very smooth, her replies were prompt and I always received all the precise information I needed. Professional, kind, and helpful. Overall, a very pleasant experience.",
    textFr: "J'ai vraiment apprécié le processus de candidature depuis le début grâce à l'excellent service de Maria. La communication était très fluide, ses réponses rapides et j'ai toujours reçu les informations précises dont j'avais besoin. Professionnelle, aimable et serviable. Une expérience très agréable dans l'ensemble.",
  },
  {
    author: "Eyal Navot",
    country: "🇮🇱 Israel",
    ratingValue: 5,
    datePublished: "2024-12-16",
    text: "Should you kindly let me express our deepest thanks and appreciation for your kindness, professionality, efficiency, excellent people skills and patience throughout the entire service regarding our Bronze package application. Your kind attitude is truly admirable — and because of you, we joined the Elite programme in the first place.",
    textFr: "Permettez-nous d'exprimer nos plus profonds remerciements pour votre gentillesse, professionnalisme, efficacité et patience tout au long de notre dossier Bronze. Votre attitude bienveillante est vraiment admirable — et c'est grâce à vous que nous avons rejoint le programme Elite.",
  },
  {
    author: "Carson Bauder",
    country: "🇺🇸 United States",
    ratingValue: 5,
    datePublished: "2024-12-10",
    text: "Thai Elite has been fantastic in organizing the visa application. Especially María. Thank you very much.",
    textFr: "Thailand Elite a été fantastique pour organiser la demande de visa. En particulier María. Merci beaucoup.",
  },
];

// Aggregate stats — from Google Business Profile (113 reviews, 4.8★)
export const aggregateRating = {
  ratingValue: 4.8,
  reviewCount: 113,
  bestRating: 5,
  worstRating: 1,
};
